export default (function ($) {

    var _instance = {}

    /**
     * Initialize the method
     *
     * @return false
     */
    _instance.init = function () {
        $(document).ready(function () {

            var search = $('#authorsSearch');
            var searchInput = $('#authorsSearchInput');
            var searchButton = search.find('button');

            if (search.length > 0) {
                var searchQuery = '';

                searchButton.on('click', function () {
                    searchQuery = $.trim(searchInput.val());
                    if (searchQuery.length > 2) {
                        $.ajax({
                            url: '/wp-admin/admin-ajax.php',
                            type: 'POST',
                            data: {
                                'action': 'wkngp_ajax_authors_search',
                                'term': searchQuery
                            },
                            beforeSend: function () {

                            },
                            success: function (result) {
                                $('.authors__content').html(result)
                            }
                        });
                    }
                });

                searchInput.on('keydown', function (e) {
                    var keyCode = (e.keyCode ? e.keyCode : e.which);
                    if (keyCode === 13) {
                        searchButton.trigger('click');
                    }
                });
            }
        });
    };

    return _instance;

})(jQuery)